import common from './zh-CN/common';
import report from './zh-CN/report';
import contentManagementCenter from './zh-CN/contentManagementCenter';
import userDataCenter from './zh-CN/userDataCenter';
import quarterReport from './zh-CN/quarterReport';
import yearReport from './zh-CN/yearReport';
import personalTokenCenter from './zh-CN/personalTokenCenter';

export default {
  ...common,
  ...report,
  ...contentManagementCenter,
  ...userDataCenter,
  ...quarterReport,
  ...yearReport,
  ...personalTokenCenter,
};
